var list = [
   {
      icon: "images/salebot_icon_01.png",
      title: "EnsSaleBot",
      at: "@EnsSaleBot",
      info: "Hot Sales/Registrations of .eth ensdomains (0.5Ξ & above)",
      pic: "images/salebot_pic_01.png",
      twitter_url: "https://twitter.com/EnsSalesBot",
   },
   {
      icon: "images/salebot_icon_02.png",
      title: "Othersidesbots",
      at: "@Othersidesbots",
      info: "Hot Sales of Otherdeed ( 5Ξ & above) , Serving Otherside & Othersideland fam. Just Koda …",
      pic: "images/salebot_pic_02.png",
      twitter_url: "https://twitter.com/OtherSideBots",
   },
   {
      icon: "images/salebot_icon_03.png",
      title: "KodaSalesBot",
      at: "@KodaSalesBot",
      info: "Koda Sales Bot, Just Koda Sales, Serving Kodas & 0therside fam. Hot Sales of Otherdeed",
      pic: "images/salebot_pic_03.png",
      twitter_url: "https://twitter.com/KodaSalesBot",
   },
   {
      icon: "images/salebot_icon_04.png",
      title: "GoblintownSales",
      at: "@GoblintownSales",
      info: "Hot Sales of GoblinTown (4Ξ & above) Just for Goblin & Goblintownwtf fam.",
      pic: "images/salebot_pic_04.png",
      twitter_url: "https://twitter.com/GoblintownSales",
   },
   {
      icon: "images/salebot_icon_05.png",
      title: "The999ClubBot",
      at: "@The999Bot",
      info: "999 Club sales Bot, Just for ENS holders 000~999.eth",
      pic: "images/salebot_pic_05.png",
      twitter_url: "https://twitter.com/The999Bot",
   },
];

export function getAlohainfoData() {
   return list;
}

var listWhatData = [
   {
      icon: "iconfont/icon_what_01.svg",
      title: "Fastest",
      info: "Sales data are scraped and posted within 30 seconds.",
   },
   {
      icon: "iconfont/icon_what_02.svg",
      title: "Most Comprehensive",
      info: "Sales data are acquired from all available NFT exchanges, marketplaces, aggregators. No missing data.",
   },
   {
      icon: "iconfont/icon_what_03.svg",
      title: "Multiple Tokens",
      info: "Prices listed in different tokens are all captured, i.e. ETH/WETH/USDC/APE, etc.",
   },
   {
      icon: "iconfont/icon_what_04.svg",
      title: "Customisable Display Mode",
      info: "AlohaBots support different ways of display of sales information, i.e. full NFT image, direct links to Opensea, etc.",
   },
   {
      icon: "iconfont/icon_what_05.svg",
      title: "Customisable Twitter Messages",
      info: "AlohaBots support customised posts’ contents, i.e. sales threshold, prefix, surfix, Twitter tags, emoji, etc. ",
   },
   {
      icon: "iconfont/icon_what_06.svg",
      title: "Customisable Sales Data Combination",
      info: "AlohaBots support sales data combination of 1-3 collections of an NFT project. ",
   },
   {
      icon: "iconfont/icon_what_07.svg",
      title: "Customisable Sales Data Acquisition",
      info: "AlohaBots support sales data acquisition of NFTs with certain specific attributes from one collection.",
   },
];
export function getAlohainfoWhatData() {
   return listWhatData;
}

var listSupportData = [
   {
      infolist: [
         "Fastest and most comprehensive",
         "Multiple display mode with two types of NFT images",
         "Customised sales data acquisition of Koda with specific attributes",
      ],
      bots: [
         {
            icon: "images/salebot_icon_03.png",
            title: "KodaSalesBot",
            pic: "images/salebot_pic_03.png",
            twitter_url: "https://twitter.com/KodaSalesBot",
         },
         {
            icon: "images/salebot_icon_02.png",
            title: "OtherSideBots",
            pic: "images/salebot_pic_02.png",
            twitter_url: "https://twitter.com/OtherSideBots",
         },
      ],
   },
   {
      infolist: [
         "Fastest and most comprehensive",
         "Display of exclusively designed image and direct link to transactions",
         "Customised sales data combination from multiple sources",
      ],
      bots: [
        {
           icon: "images/salebot_icon_01.png",
           title: "EnsSaleBot",
           pic: "images/salebot_pic_01.png",
           twitter_url: "https://twitter.com/EnsSalesBot",
        },
        {
           icon: "images/salebot_icon_05.png",
           title: "The999ClubBot",
           pic: "images/salebot_pic_05.png",
           twitter_url: "https://twitter.com/The999Bot",
        },
     ],
   },
   {
      infolist: [
         "Fastest and most comprehensive",
         "Customised twitter message with prices listed in multiple tokens",
         "Display of full NFT image and direct link to transactions",
      ],
      bots: [
        {
           icon: "images/salebot_icon_04.png",
           title: "GoblintownSales",
           pic: "images/salebot_pic_04.png",
           twitter_url: "https://twitter.com/GoblintownSales",
        },
        {
           icon: "images/salebot_icon_06.png",
           title: "lilheroesSales",
           pic: "images/salebot_pic_06.png",
           twitter_url: "https://twitter.com/lilheroesSales",
        },
     ],
   },
];
export function getAlohaSupportData() {
   return listSupportData;
}
